import { useEffect, useState } from 'react';
import './Poster.css'; 
import CustomCalendar from '../../components/Calendar/Calendar';
import { getAllEvents } from '../../http/eventAPI';
import EventItem from '../../components/EventItem/EventItem';
import { IEventItem } from '../../interfaces/IEventItem';

const Poster: React.FC = () => {
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [events, setEvents] = useState<IEventItem[]>([]);
    const [filteredEvents, setFilteredEvents] = useState<IEventItem[]>([]);
    const [searchQuery, setSearchQuery] = useState<string>('');
    const [isVisible, setVisible] = useState<boolean>(false);

    useEffect(() => {
        setVisible(true);
    }, [])
    
    const normalizeDate = (date: Date): Date => {
        const normalized = new Date(date);
        normalized.setHours(0, 0, 0, 0);
        return normalized;
    };
    
    const handleDateSelect = (date: Date) => {
        const normalizedDate = normalizeDate(date);
        
        if (startDate && !endDate && startDate.getTime() === normalizedDate.getTime()) {
            setStartDate(null);
            setEndDate(null);
        } else if (!startDate) {
            setStartDate(normalizedDate);
            setEndDate(null);
        } else if (startDate && !endDate) {
            if (normalizedDate > startDate) {
                setEndDate(normalizedDate);
            } else {
                setStartDate(normalizedDate);
                setEndDate(startDate);
            }
        } else {
            setStartDate(normalizedDate);
            setEndDate(null);
        }
    };
    
    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value.toLowerCase());
    };
    
    useEffect(() => {
        getAllEvents()
            .then((response) => {
                if (Array.isArray(response)) {
                    const now = new Date(); 
                    
                    const transformedEvents: IEventItem[] = response.flatMap((event) =>
                        event.eventDatesAndTickets
                            .filter((date) => new Date(date.start_time) > now) 
                            .map((date) => ({
                                id: event.id,
                                title: event.title,
                                location: event.location,
                                image: event.image,
                                eventDate: date.start_time,
                                dateId: date.id ?? ''
                            }))
                    );
                    setEvents(transformedEvents);
                }
            })
            .catch(() => {
                console.log('Ошибка при получении информации о событиях.');
            });
    }, []);
    
    useEffect(() => {
        let filtered = events;
        
        if (startDate && endDate) {
            const normalizedEndDate = normalizeDate(endDate);
            
            filtered = filtered.filter(event => {
                const eventDate = normalizeDate(new Date(event.eventDate));
                return eventDate >= startDate && eventDate <= normalizedEndDate;
            });
        } else if (startDate) {
            filtered = filtered.filter(event => {
                const eventDate = normalizeDate(new Date(event.eventDate));
                return eventDate.getTime() === startDate.getTime();
            });
        }
        
        if (searchQuery) {
            filtered = filtered.filter(event =>
                event.title.toLowerCase().includes(searchQuery) ||
                event.location.toLowerCase().includes(searchQuery)
            );
        }
        
        setFilteredEvents(filtered);
    }, [startDate, endDate, events, searchQuery]);
    
    return (
        <div className={`events ${isVisible ? 'visible' : ''}`}>
            <div className='events_calendar_container'>
                <h2 className='calendar_title'>Афиша событий в <span>“Miartcom”</span></h2>
                <CustomCalendar onDateSelect={handleDateSelect} startDate={startDate} endDate={endDate} />
            </div>
            
            <div className='events_searchContainer'>
                <input 
                    type="text" 
                    placeholder="Поиск событий" 
                    value={searchQuery} 
                    onChange={handleSearch} 
                />
            </div>
            
            <div className='events_eventsItems'>
                {filteredEvents.map((e, idx) => (
                    <EventItem 
                        key={idx}
                        id={e.id}
                        title={e.title}
                        location={e.location}
                        image={e.image}
                        eventDate={e.eventDate} 
                        dateId={e.dateId}                                
                    />
                ))}
            </div>
        </div>
    );
};

export default Poster;
